"use strict";

angular.module("core")
.controller("PartnershipsConfirmationController", function(
    $rootScope, $scope, $attrs, close, PartnershipService, FormError, FlashBag, EMAIL_MAXLENGTH
) {
    var _this = this;
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    var INPUT_NAME_PREFIX = "buyer_number_";

    this.message = $attrs.message;
    this.selectedInstances = $attrs.selectedInstances;
    this.text = $attrs.text;
    this.invite = true;
    this.showInviteCheckbox = $attrs.showInviteCheckbox;

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if (confirm) {
            close.apply(this, arguments);
        }
    };

    this.confirm = function() {
        _this.close(true);
    };

    this.validateNumberTogether = function(id) {
        $scope.partnershipsForm[INPUT_NAME_PREFIX + id].$setValidity("used", true);
        var value = "";
        for (var i = 0; i < this.selectedInstances.length; i++) {
            if (id == this.selectedInstances[i].customer_id) {
                continue; // don't compare input with itself
            }

            value = $scope.partnershipsForm[INPUT_NAME_PREFIX + id].$modelValue;
            if (value == this.selectedInstances[i].buyer_number || value == this.selectedInstances[i].new_buyer_number) {
                $scope.partnershipsForm[INPUT_NAME_PREFIX + id].$setValidity("used", false);
                break;
            }
        }
    };

    this.submit = function() {
        if ($scope.partnershipsForm.$valid) {
            var buyer_numbers = [];
            angular.forEach($scope.partnershipsForm, function(value, key) {
                if (key[0] !== "$" && value.hasOwnProperty("$modelValue")) {
                    buyer_numbers.push({"id": key.replace(INPUT_NAME_PREFIX, ""), "number": value.$modelValue});
                }
            });

            PartnershipService.updateOrCreateCustomersInBatch(buyer_numbers).then(
                function onSuccess(data) {
                    $rootScope.UpdateCurrentNumbers();
                    $scope.$element.modal("hide");
                    $scope.$element.remove();
                    close.apply(_this, [{
                        selectedInstances: _this.selectedInstances,
                        invite: _this.invite
                    }]);

                },
                function onError(response) {
                    if (Array.isArray(response.data)) {
                        angular.forEach(response.data, function(value, key) {
                            $scope.partnershipsForm[INPUT_NAME_PREFIX + value.id].$setValidity("used", false);
                        });
                        FormError.focus("partnershipsForm");
                    }
                    else {
                        FlashBag.alertWithContainer("danger", "flash-partnership-confirm-modal");
                    }
                }
            );
        }
        else {
            FormError.focus("partnershipsForm");
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/action-modal/group-partnership-confirmation.modal.js
// module id = 903
// module chunks = 0